import { type Patient } from './Patient.js';

export enum EventCategory {
  MOTION = 'motion-detection',
  WELLNESS_CHECK = 'wellness-check',
  EMERGENCY = 'emergency',
}

export enum EventPriority {
  HIGH = 1,
  MEDIUM = 2,
  LOW = 3,
}

export type EventData = {
  [key: string]: any;
};

export type Event = {
  id: string;
  category: EventCategory;
  patient: Patient;
  patientId: string;
  start: string;
  priority: EventPriority;
  end?: string;
  completingUserId?: string;
};
